import React, { useEffect } from "react";
import { renderRoutes } from "react-router-config";
import {
  setIsMobile,
  setMessage,
  setCurUrl,
  setIsWideSreen,
  setCurMenu,
} from "../store/global/actionCreators";
import {
  quickLogin,
  getLoginToken,
  setLoginToken,
  getUserLoginInfo,
} from "../store/user/actionCreators";
import { showMessage } from "../components/util/NoticeMessage";
import { pathPrefix } from "src/util";
import { checkPrivilege } from "../util/util";
import { connect } from "react-redux";
function Home(props) {
  const {
    route,
    setIsMobile,
    setIsWideSreen,
    message,
    setMessage,
    curUrl,
    userInfo,
    setCurUrl,
    setCurMenu,
    getUserLoginInfo,
  } = props;
  useEffect(() => {
    const clientWidth = document.body.clientWidth;
    const isMobile = clientWidth <= 992;
    setIsMobile(isMobile);
    setIsWideSreen(clientWidth > 1500);
    window.onresize = () => {
      const curClientWidth = document.body.clientWidth;
      setIsMobile(curClientWidth <= 992);
      setIsWideSreen(clientWidth > 1500);
    };
  }, [setIsMobile, setIsWideSreen]);

  useEffect(() => {
    if (message) {
      showMessage(message.type, message.msg, "");
      setMessage(null);
    }
  }, [message, setMessage]);

  useEffect(() => {
    console.log("curUrl", curUrl, pathPrefix);
    const userAgent = navigator.userAgent.toLowerCase();
    const keys = document.cookie.match(/[^ =;]+(?==)/g) || [];
    const auth = !!keys.includes("token");
    if ((userAgent.includes("taiji") || userAgent.includes("zhixin")) && auth) {
      let url = pathPrefix + "/main/index";
      curUrl.url = url;
      setCurUrl(curUrl);
      getUserLoginInfo();
    }
    if (
      curUrl &&
      curUrl.url !== pathPrefix + "/main/404" &&
      curUrl.url !== pathPrefix + "/login"
    ) {
      // 全局监听url变化，统一对url做出处理，后续对接统一入口的时候可以在这边统一将所有的url变化使用postMessage发送到外面去。
      // if (isLogin) {
      if (
        curUrl.url !== pathPrefix + "/main/404" &&
        !checkPrivilege(curUrl.url, userInfo.privileges, userInfo.state) &&
        !auth
      ) {
        props.history.push(pathPrefix + "/main/404");
      } else {
        const routeList = props.route.routes[1].routes;
        if (curUrl.state) {
          props.history.push({ pathname: curUrl.url, state: curUrl.state });
        } else {
          props.history.push(curUrl.url);
        }
        let jumpIndex = -1;
        for (let i = 0; i < routeList.length; i++) {
          const routeItem = routeList[i];
          if (curUrl.url?.indexOf(routeItem.path) >= 0) {
            jumpIndex =
              routeItem.index !== null && routeItem.index !== undefined
                ? routeItem.index
                : -1;
            break;
          }
        }
        setCurMenu(jumpIndex);
      }
    }
  }, [curUrl]);

  return <>{renderRoutes(route.routes)}</>;
}

const mapStateToPorps = (state) => ({
  userInfo: state.user.userInfo,
  message: state.global.message,
  curUrl: state.global.curUrl,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsMobile(data) {
      dispatch(setIsMobile(data));
    },
    quickLogin(data) {
      dispatch(quickLogin(data));
    },
    getUserLoginInfo(data) {
      dispatch(getUserLoginInfo(data));
    },
    getLoginToken() {
      dispatch(getLoginToken());
    },
    setLoginToken(data) {
      dispatch(setLoginToken(data));
    },
    setMessage(data) {
      dispatch(setMessage(data));
    },
    setCurUrl(data) {
      dispatch(setCurUrl(data));
    },
    setIsWideSreen(data) {
      dispatch(setIsWideSreen(data));
    },
    setCurMenu(data) {
      dispatch(setCurMenu(data));
    },
  };
};

export default connect(mapStateToPorps, mapDispatchToProps)(React.memo(Home));
